import { Alert } from '@designsforhealth/dfh-react-components'
import React from 'react'

import {
  ackAutomaticallyUpdatedCartItem,
  useItemsAutomaticallyUpdated,
} from '../../lib/cart/state/cart-items/cart-item-update'

export interface CartItemErrorsProps {
  cartItemId: string
}

export const CartItemAlert: React.FC<CartItemErrorsProps> = ({ cartItemId }) => {
  const autoUpdatedCartItems = useItemsAutomaticallyUpdated()
  const errantItemUpdated = autoUpdatedCartItems.get(cartItemId)

  return errantItemUpdated ? (
    <Alert type="attention" onDismiss={() => ackAutomaticallyUpdatedCartItem(cartItemId)}>
      {errantItemUpdated.error === 'ProductQuantityBelowMinOrderQty'
        ? `Quantity updated to ${
            errantItemUpdated.cartItem.product.stock_configuration?.min_sale_qty || 1
          } according to the minimum order requirements for this product.`
        : errantItemUpdated.error === 'ProductQuantityAboveMaxOrderQty'
          ? `Quantity updated to ${
              errantItemUpdated.cartItem.product.stock_configuration?.max_sale_qty || 1
            } according to the maximum order requirements for this product.`
          : 'This item was updated. Please check your cart before proceeding with checkout.'}
    </Alert>
  ) : null
}
